import React, { useState, useRef, useEffect } from "react";

import "./../Steps.scss";
import {
  Button,
  Form,
  Input,
  Select,
  Radio,
  Space,
  Empty,
  Tag,
  Modal,
} from "antd";
import { Row, Col, Container } from "react-bootstrap";

import deleteIcon from "../../../../assets/images/png/delete_icon.png";
import infoIcon from "../../../../assets/images/png/info.png";
import { Popover } from "antd";
import { Label } from "evergreen-ui";

function SelectElements({
  key,
  id,
  firstSelectValue,
  secondSelectOptions,
  onChange,
  onRemove,
  specialities,
  handleDuplicateSpeciality,
  handleDuplicateService,
  handleDuplicateDisease,
  handleSpecialityChange,
  handleServiceChange,
  handleDiseaseChange,
  thirdSelectOptions,
  form,
}) {
  const { Option } = Select;
  let index = 0;

  const inputRef = useRef(null);
  const [name, setName] = useState("");
  const [showAddItem, setShowAddItem] = useState(false); // State to control the visibility of Add item field and button
  const [items, setItems] = useState([]);
  const [showAddDiseaseBtn, setShowAddDiseaseBtn] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [selectedConditions, setSelectedConditions] = useState([]);
  const [instruction, setInstruction] = useState(false);

  const [selectedServices, setSelectedServices] = useState([]);
  const inputServiceRef = useRef(null);
  const [nameService, setNameService] = useState("");
  const [showAddItemService, setShowAddItemService] = useState(false);

  const modalCondition = (e) => {
    setInstruction(true);
  };

  const handleSearch = (value) => {
    setSearchValue(value.toLowerCase());
  };

  const handleFirstSelectChange = (e) => {
    onChange(id, e);
  };

  const content = (
    <div>
      <p className="info">
        In case you don't make a selection, we will assign the most common
        <br></br> diseases related to your speciality to boost your visibility
        on our<br></br> platform.
      </p>
    </div>
  );

  const modalStyle = {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
  };

  // const handleConditionsChange = (value) => {
  //   console.log({value})
  //   setShowAddItem(!showAddItem);
  //   setShowAddItem(value.includes("Other"));
  //   if(value?.[0] !== "Other") {
  //     handleDiseaseChange(value);
  //   }

  //   else {
  //     console.log("otherval")
  //     return null;
  //   }

  // };

  // const handleConditionsChange = (values) => {
  //   console.log(values[0], "values")
  //   const excludedValue = 'Other';

  //   // Check if the excluded value is included in the selected values
  //   if (values.includes(excludedValue)) {
  //     // Remove the excluded value from the selected values
  //     const filteredValues = values.filter((value) => value !== excludedValue);
  //     setSelectedConditions(filteredValues);
  //   } else {
  //     setSelectedConditions(values);
  //   }
  // };

  const handleConditionsChange = (values) => {
    const excludedValue = "Other";
    setShowAddItem(!showAddItem);
    setShowAddItem(values.includes("Other"));
    handleDiseaseChange(values);
    const filteredValues = values.filter((value) => value !== excludedValue);
    setSelectedConditions(filteredValues);
  };

  const onNameChange = (event) => {
    setName(event.target.value);
  };

  function filterConditionOption(input, option) {
    const excludedValue = "Other";

    if (option.props.value === excludedValue) {
      return false;
    }

    return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  const addItem = (e, id) => {
    e.preventDefault();
    if (name !== "Other") {
      // setItems([...items, name || `New item ${index++}`]);// Add new item at the end
      setItems([name || `New item ${index++}`, ...items]); // Add new item at the beginning
    }
    const previousDiseaseValue = form?.getFieldValue(`condition${id}`) || "";

    if (!previousDiseaseValue) {
      form?.setFieldsValue({
        [`condition${id}`]: [name],
      });
    } else {
      form?.setFieldsValue({
        [`condition${id}`]: [...previousDiseaseValue, name],
      });
    }

    setName("");
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  function handleDiseaseSearch(value) {
    const filteredOptions = thirdSelectOptions?.filter((item) => {
      return item?.name?.toLowerCase()?.startsWith(value?.toLowerCase());
    });

    if (filteredOptions.length === 0) {
      setShowAddItem(true);
    } else {
      setShowAddItem(false);
    }
  }

  const handleConditionsChange2 = (values) => {
    const excludedValue = "Other";
    setShowAddItemService(!showAddItemService);
    setShowAddItemService(values.includes("Other"));
    handleServiceChange(values);
    const filteredValues = values.filter((value) => value !== excludedValue);
    setSelectedServices(filteredValues);
  };

  function handleServicesSearch(value) {
    const filteredOptions = secondSelectOptions?.filter((item) => {
      return item?.name?.toLowerCase()?.startsWith(value?.toLowerCase());
    });

    if (filteredOptions.length === 0) {
      setShowAddItem(true);
    } else {
      setShowAddItem(false);
    }
  }

  function filterServiceOption(input, option) {
    const excludedValue = "Other";

    if (option.props.value === excludedValue) {
      return false;
    }

    return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  const handleSearchService = (value) => {
    setSearchValue(value.toLowerCase());
  };

  const addItemService = (e, id) => {
    e.preventDefault();
    if (nameService !== "Other") {
      // setItems([...items, name || `New item ${index++}`]);// Add new item at the end
      setItems([nameService || `New item ${index++}`, ...items]); // Add new item at the beginning
    }
    const previousDiseaseValue = form?.getFieldValue(`service${id}`) || "";

    if (!previousDiseaseValue) {
      form?.setFieldsValue({
        [`service${id}`]: [nameService],
      });
    } else {
      form?.setFieldsValue({
        [`service${id}`]: [...previousDiseaseValue, nameService],
      });
    }

    setNameService("");
    setTimeout(() => {
      inputServiceRef.current?.focus();
    }, 0);
  };

  const onNameChangeService = (event) => {
    setNameService(event.target.value);
  };

  return (
    <>
      {id != 1 && (
        <Col lg={12} md={12}>
          <div className="spacialtyBo mt-3">
            <h3>Specialty</h3>
            <div className="text-end">
              {" "}
              <img src={deleteIcon} style={{cursor: 'pointer'}} onClick={(e) => onRemove(id)}></img>
            </div>
          </div>
        </Col>
      )}
      <Col lg={6} md={6} className="selectBox ">
        <Form.Item
          name={`speciality${id}`}
          label=" Speciality"
          rules={[
            {
              required: true,
              message: "Speciality is required",
            },
            {
              validator: handleDuplicateSpeciality,
            },
          ]}
        >
          <Select
            placeholder="Ent Specialist"
            onChange={(e) => {
              onChange(id, e);
              handleSpecialityChange(e);
            }}
            showSearch={true}
            optionFilterProp="children"
            filterOption={(input, option) => {
              return option.children
                ?.toString()
                .toLowerCase()
                .startsWith(input.toLowerCase());
            }}
          >
            {specialities?.map((item) => (
              <Option key={item?.id} value={item?.id}>
                {item?.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      {/* <Col lg={6} md={6} className="selectBox ">
        <Form.Item
          name={`service${id}`}
          label="Service"
          rules={[
            {
              required: true,
              message: "Service is required",
            },
            {
              validator: handleDuplicateService,
            },
          ]}
        >
          <Select
            placeholder="Select service"
            onChange={(e) => handleServiceChange(e)}
          >
            {secondSelectOptions?.map((option) => (
              <Option key={option?.id} value={option?.id}>
                {option?.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col> */}
      <Col lg={6} md={6} className="selectBox condition_box select3BoxPadding">
        <Form.Item
          name={`service${id}`}
          rules={[
            { required: true, message: "Please select at least one service you are offering." },
            { validator: handleDuplicateDisease },
          ]}
          label={
            <Label>
              Services{" "}
            </Label>
          }
        >
          <Select
            mode="multiple"
            maxTagCount="responsive"
            placeholder="Select services or enter your own"
            className="select_des newtest newDesignDropdown"
            onChange={(e) => handleConditionsChange2(e)}
            showSearch={false}
            // onSearch={handleServicesSearch}
            filterOption={filterConditionOption}
            dropdownClassName="dropdown_box_checkbox"
            dropdownRender={(menu) => {
              const selectedValues = form?.getFieldValue(`service${id}`) || [];

              return (
                <>
                  <h5
                    className="headingcon"
                    style={{ fontWeight: "bold", marginBottom: "8px" }}
                  >
                    Select Service(s)
                  </h5>

                  <div className="serchFieldBox p-0 m-0">
                    <Input
                      placeholder="Search services"
                      onChange={(e) => handleSearchService(e.target.value)}
                      allowClear
                      style={{
                        borderRadius: "5px",
                        padding: "6px 8px",
                      }}
                    />
                    <span className="iconSerch"></span>
                  </div>

                  {selectedValues.length > 0 && (
                    <div
                      style={{ borderBottom: "1px solid #f0f0f0" }}
                      className="tagsDrops"
                    >
                      <h6>Selected:</h6>
                      <div
                        style={{
                          marginTop: "8px",
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: "15px",
                        }}
                      >
                        {selectedValues.map((value) => {
                          const selectedItem = secondSelectOptions?.find(
                            (option) => option?.id === value
                          );
                          const label = selectedItem
                            ? selectedItem.name
                            : value;
                          const isCustomItem = !secondSelectOptions?.some(
                            (option) => option.name === label
                          );

                          return (
                            <Tag
                              key={value}
                              className={`className ${
                                isCustomItem ? "forTagCustom" : ""
                              }`}
                              closable
                              onClose={(e) => {
                                e.preventDefault(); // Prevent default tag remove behavior
                                const updated = selectedValues.filter(
                                  (v) => v !== value
                                );
                                form.setFieldsValue({
                                  [`service${id}`]: updated,
                                });
                                handleConditionsChange2(updated);
                              }}
                              style={{
                                margin: 0,
                                backgroundColor: isCustomItem
                                  ? "rgba(142, 150, 160, 0.50)"
                                  : "#EEF1FA",
                                color: "#0F345A",
                                borderRadius: "20px",
                                borderColor: "#0F345A",
                              }}
                            >
                              {label}
                            </Tag>
                          );
                        })}
                      </div>
                      <h6 className="mb-3">All Services</h6>
                    </div>
                  )}
                  {menu}
                  {showAddItemService && (
                    <Space
                      style={{ padding: "0 8px 4px" }}
                      className="add_item"
                    >
                      <Input
                        placeholder="Enter service you treat"
                        ref={inputServiceRef}
                        value={nameService}
                        onChange={onNameChangeService}
                        className="textfield"
                      />
                      <Button
                        type="text"
                        onClick={(e) => addItemService(e, id)}
                        className={name ? "activebtn" : ""}
                      >
                        Add
                      </Button>
                    </Space>
                  )}
                </>
              );
            }}
            options={secondSelectOptions?.map((item) => ({
              label: item?.name,
              value: item?.id,
            }))}
            optionLabelProp="label"
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            tagRender={(props) => {
              const { label, value, closable, onClose } = props;
              const isCustomItem = !secondSelectOptions?.some(
                (option) => option?.name === label
              );

              return (
                <Tag
                  className={`className ${isCustomItem ? "forTagCustom" : ""}`}
                  closable={closable}
                  onClose={onClose}
                  style={{
                    marginLeft: 8,
                    backgroundColor: isCustomItem
                      ? "rgba(142, 150, 160, 0.50)"
                      : "#EEF1FA",
                    color: "#0F345A",
                    borderRadius: "20px",
                    borderColor: "#0F345A",
                  }}
                >
                  {label}
                </Tag>
              );
            }}
          />
        </Form.Item>
      </Col>
      <Col
        lg={12}
        md={12}
        className="selectBox condition_box select3BoxPadding"
      >
        <Form.Item
          name={`condition${id}`}
          // rules={[
          //   { required: true, message: "Please select at least one Condition to be treated." },
          //   { validator: handleDuplicateDisease },
          // ]}
          label={
            <Label>
              Conditions Treated{" "}
            </Label>
          }
        >
          <Select
            mode="multiple"
            maxTagCount="responsive"
            placeholder="Select conditions"
            className="select_des newtest newDesignDropdown"
            onChange={handleConditionsChange}
            showSearch={false}
            // onSearch={handleDiseaseSearch}
            filterOption={filterConditionOption}
            dropdownClassName="dropdown_box_checkbox"
            dropdownRender={(menu) => {
              const selectedValues =
                form?.getFieldValue(`condition${id}`) || [];

              return (
                <>
                  <h5
                    className="headingcon"
                    style={{ fontWeight: "bold", marginBottom: "8px" }}
                  >
                    Select Conditions Treated
                  </h5>

                  <div className="serchFieldBox p-0 m-0">
                    <Input
                      placeholder="Search conditions"
                      onChange={(e) => handleSearch(e.target.value)}
                      allowClear
                      style={{
                        borderRadius: "5px",
                        padding: "6px 8px",
                      }}
                    />
                    <span className="iconSerch"></span>
                  </div>

                  {selectedValues.length > 0 && (
                    <div
                      style={{ borderBottom: "1px solid #f0f0f0" }}
                      className="tagsDrops"
                    >
                      <h6>Selected:</h6>
                      <div
                        style={{
                          marginTop: "8px",
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: "15px",
                        }}
                      >
                        {selectedValues?.map((value) => {
                          const selectedItem = thirdSelectOptions?.find(
                            (option) => option?.id === value
                          );
                          const label = selectedItem
                            ? selectedItem.name
                            : value;
                          const isCustomItem = !thirdSelectOptions?.some(
                            (option) => option.name === label
                          );

                          return (
                            <Tag
                              key={value}
                              className={`className ${
                                isCustomItem ? "forTagCustom" : ""
                              }`}
                              closable
                              onClose={(e) => {
                                e.preventDefault(); // Prevent default tag remove behavior
                                const updated = selectedValues.filter(
                                  (v) => v !== value
                                );
                                form.setFieldsValue({
                                  [`condition${id}`]: updated,
                                });
                                handleConditionsChange(updated);
                              }}
                              style={{
                                margin: 0,
                                backgroundColor: isCustomItem
                                  ? "rgba(142, 150, 160, 0.50)"
                                  : "#EEF1FA",
                                color: "#0F345A",
                                borderRadius: "20px",
                                borderColor: "#0F345A",
                              }}
                            >
                              {label}
                            </Tag>
                          );
                        })}
                      </div>
                      <h6 className="mb-3">All Services</h6>
                    </div>
                  )}

                  {menu}

                  {showAddItem && (
                    <Space
                      style={{ padding: "0 8px 4px" }}
                      className="add_item"
                    >
                      <Input
                        placeholder="Enter condition you treat"
                        ref={inputRef}
                        value={name}
                        onChange={onNameChange}
                        className="textfield"
                      />
                      <Button
                        type="text"
                        onClick={(e) => addItem(e, id)}
                        className={name ? "activebtn" : ""}
                      >
                        Add
                      </Button>
                    </Space>
                  )}
                </>
              );
            }}
            options={thirdSelectOptions?.map((item) => ({
              label: item?.name,
              value: item?.id,
            }))}
            optionLabelProp="label"
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            tagRender={(props) => {
              const { label, value, closable, onClose } = props;
              const isCustomItem = !thirdSelectOptions?.some(
                (option) => option?.name === label
              );

              return (
                <Tag
                  className={`className ${isCustomItem ? "forTagCustom" : ""}`}
                  closable={closable}
                  onClose={onClose}
                  style={{
                    marginLeft: 8,
                    backgroundColor: isCustomItem
                      ? "rgba(142, 150, 160, 0.50)"
                      : "#EEF1FA",
                    color: "#0F345A",
                    borderRadius: "20px",
                    borderColor: "#0F345A",
                  }}
                >
                  {label}
                </Tag>
              );
            }}
          />
        </Form.Item>
      </Col>
      <Modal
        title=""
        centered
        visible={instruction}
        onOk={() => setInstruction(false)}
        onCancel={() => setInstruction(false)}
        bodyStyle={modalStyle}
        mask={false}
        wrapClassName="scrollModal"
        className=" modal_ins hideclosebtn"
      >
        <div className="modal_prompt">
          <h6>Select conditions you treat</h6>
          <p>
            In case you don't make a selection, we will assign the most common
            diseases related to your speciality to boost your visibility on our
            platform.
          </p>
          <div className="text-center">
            <Button
              className="btn btn-modal"
              onClick={() => setInstruction(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>
      {/* {id != 1 && (
        <>
          <Col md={11} lg={11}></Col>

          <Col md={1} lg={1}>
            <div className="text-end">
              {" "}
              <img src={deleteIcon} onClick={(e) => onRemove(id)}></img>
            </div>
            <BsTrash style={{ cursor: 'pointer' }} />
          </Col>
        </>
      )} */}
    </>
  );
}
export default SelectElements;
